import {
  applyComparisonOperator,
  applyDateRangeFilter,
  parseFilters,
} from '../../../libs/filter.lib'
import {
  QueryStringFilter,
  QueryStringSort,
} from '../../../models/query-string.model'
import {
  InvoiceSearchField,
  InvoiceSearchParams,
  InvoiceSortField,
} from '../models/invoice-search.model'

export function parseInvoiceFilters(
  params: InvoiceSearchParams,
  filters: InvoiceSearchParams,
): InvoiceSearchParams {
  return parseFilters(params, filters, invoiceFilterParams)
}

/**
 * Parse invoice sort params
 * @param params - the search params
 * @param sort - the sort params
 * @returns the search params updated
 */
export function invoiceSortParams(
  params: InvoiceSearchParams,
  sort: QueryStringSort<InvoiceSortField>,
): InvoiceSearchParams {
  const searchParams: InvoiceSearchParams = {}

  switch (sort.field) {
    case 'header.date':
      searchParams.sort = 'header.date'
      searchParams.order = sort.order
      break
    case 'header.invoiceNumber':
      searchParams.sort = 'header.invoiceNumber'
      searchParams.order = sort.order
      break
    case 'header.rifDate':
      searchParams.sort = 'header.rifDate'
      searchParams.order = sort.order
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}

/**
 * Parse invoice filter params
 * @param params - the search params
 * @param filter - the filter params
 * @returns the search params updated
 */
export function invoiceFilterParams(
  params: InvoiceSearchParams,
  filter: QueryStringFilter<InvoiceSearchField>,
): InvoiceSearchParams {
  const searchParams: InvoiceSearchParams = {}
  const value = Array.isArray(filter.value)
    ? filter.value.length
      ? filter.value[0]
      : undefined
    : filter.value

  switch (filter.field) {
    case '_id':
      if (filter.operator === '=') {
        searchParams._id = filter.value
      }
      break
    case 'documentType':
      if (filter.value !== null) {
        searchParams['documentType'] = filter.value
      }
      break
    /* case 'header.currency':
      if (filter.value !== null) {
        searchParams['header.currency'] = filter.value
      }
      break */
    case 'header.date':
      if (filter.operator === 'between') {
        Object.assign(
          searchParams,
          applyDateRangeFilter(
            'header.date',
            Array.isArray(filter.value) ? (filter.value as Date[]) : [],
            searchParams,
          ),
        )
        break
      }
      Object.assign(
        searchParams,
        applyComparisonOperator(
          'header.date',
          filter.operator,
          value,
          searchParams,
        ),
      )
      break
    case 'header.externalrifInvoice':
      if (filter.operator === '=') {
        searchParams['header.externalrifInvoice'] = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['header.externalrifInvoice:ct'] = filter.value
      }
      break
    case 'header.channel':
      searchParams['header.channel'] = filter.value
      break
    case 'header.invoiceNumber':
      if (filter.operator === '=') {
        searchParams['header.invoiceNumber'] = filter.value
      } else if (filter.operator === '<') {
        searchParams['header.invoiceNumber:lt'] = filter.value
      } else if (filter.operator === '<=') {
        searchParams['header.invoiceNumber:le'] = filter.value
      } else if (filter.operator === '>') {
        searchParams['header.invoiceNumber:gt'] = filter.value
      } else if (filter.operator === '>=') {
        searchParams['header.invoiceNumber:ge'] = filter.value
      }
      break
    case 'header.paymentType':
      if (filter.value !== null) {
        searchParams['header.paymentType'] = filter.value
      }
      break
    case 'header.rifDate':
      if (filter.operator === 'between') {
        Object.assign(
          searchParams,
          applyDateRangeFilter(
            'header.rifDate',
            Array.isArray(filter.value) ? (filter.value as Date[]) : [],
            searchParams,
          ),
        )
        break
      }
      Object.assign(
        searchParams,
        applyComparisonOperator(
          'header.rifDate',
          filter.operator,
          value,
          searchParams,
        ),
      )
      break
    case 'header.rifInvoice':
      if (filter.operator === '=') {
        searchParams['header.rifInvoice'] = filter.value
      }
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}
